import { render, staticRenderFns } from "./sale-product-by-group.vue?vue&type=template&id=2b2e6ca5&scoped=true&"
import script from "./sale-product-by-group.vue?vue&type=script&lang=js&"
export * from "./sale-product-by-group.vue?vue&type=script&lang=js&"
import style0 from "./sale-product-by-group.vue?vue&type=style&index=0&id=2b2e6ca5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2e6ca5",
  null
  
)

export default component.exports